import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { environment } from '@env/environment';
import { EthanAIAbilitiesService } from '@services/ethan-ai-abilities.service';

type CalcCodeField = {
  name: string;
  label: string;
  type: string;
  related_to_type: string;
};

type CalcCodeAIAbilityData = {
  listOfFields: CalcCodeField[];
  fieldLabel: string;
};

@Component({
  selector: 'calc-code-ai-ability',
  templateUrl: './calc-code-ai-ability.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalcCodeAIAbilityComponent extends OnDestroyMixin implements OnInit {
  ui = { loading: false };
  form = new FormGroup({
    fieldLabel: new FormControl(''),
    askForCalcCodeInput: new FormControl('', [Validators.required]),
    ethanResponse: new FormControl('', [Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<CalcCodeAIAbilityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CalcCodeAIAbilityData,
    private readonly ethanService: EthanAIAbilitiesService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.form.patchValue({ fieldLabel: this.data.fieldLabel });
    this.form.get('fieldLabel').disable();
  }

  invokeAbility(): void {
    if (!this.form.value.askForCalcCodeInput) return;

    const inputsData = {
      inputs: {
        list_of_fields: this.data.listOfFields,
        input: this.form.value.askForCalcCodeInput,
      },
    };

    this.ui.loading = true;
    this.ethanService
      .useCalcCodeAbility(inputsData)
      .pipe(untilComponentDestroyed(this))
      .subscribe((res) => {
        this.form.patchValue({ ethanResponse: this.formatResponse(res.output) });
        this.ui.loading = false;
      });
  }

  private formatResponse(output: string): string {
    return output ? output.replace(/`/g, '').replace(/ruby/g, '').replace(/"/g, '').trim() : '';
  }

  useCode(): void {
    this.dialogRef.close(this.form.value.ethanResponse);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
